const ROLE_TR: Record<string, string> = {
  ROLE_SUPER_ADMIN: 'Süper Admin',
  ROLE_ADMIN: 'Admin',
  ROLE_MANAGER: 'Yönetici',
  ROLE_USER: 'Çalışan',
};
const ROLE_PRIORITY = ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_USER'];

export const roleLabelTr = (role?: string | null): string =>
  (role && ROLE_TR[role]) || role || '';

// Çoklu rolde en yetkili olanı Türkçe göster: [ROLE_MANAGER, ROLE_USER] -> "Yönetici"
export const primaryRoleLabelTr = (roles?: string[] | null): string => {
  if (!roles || roles.length === 0) return 'Rol yok';
  const top = ROLE_PRIORITY.find((r) => roles.includes(r));
  return top ? ROLE_TR[top] : roles.map(roleLabelTr).join(', ');
};

const POSITION_TR: Record<string, string> = {
  EMPLOYEE: 'Çalışan',
  MANAGER: 'Müdür',
  ADMIN: 'Yönetici',
};
// Bilinen enum pozisyonları Türkçeleştir; serbest-metin pozisyonu olduğu gibi bırak.
export const positionLabelTr = (position?: string | null): string => {
  if (!position) return '';
  return POSITION_TR[position.toUpperCase()] || position;
};
